import { render, staticRenderFns } from "./ChangePhone.vue?vue&type=template&id=61e9c438&scoped=true&"
import script from "./ChangePhone.vue?vue&type=script&lang=js&"
export * from "./ChangePhone.vue?vue&type=script&lang=js&"
import style0 from "./ChangePhone.vue?vue&type=style&index=0&id=61e9c438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e9c438",
  null
  
)

export default component.exports